import { render, staticRenderFns } from "./JcdcLabeledText.vue?vue&type=template&id=f99fbd78"
import script from "./JcdcLabeledText.vue?vue&type=script&lang=ts"
export * from "./JcdcLabeledText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports